export default __webpack_public_path__ + "static/media/download-invoice.a2ea5a2a.svg";